import { Button } from '@acpaas-ui/react-components';

const AdvancedSearchActions = ({ className = '', onClear, onSearch }) => {
  return (
    <div className={`spo-m-advanced-search-actions ${className}`}>
      {onClear && (
        <Button type="danger" outline onClick={onClear}>
          Wissen
        </Button>
      )}
      <Button type="primary" className="u-margin-left" iconRight="ai-search" onClick={onSearch}>
        Zoeken
      </Button>
    </div>
  );
};

export default AdvancedSearchActions;
